import { MessageSequenceStatus } from '@api'
import { z } from 'zod'

export const MessageMediaSchema = z.object({
  sorting: z.number().int().optional(),
  mediaId: z.number().int().nonnegative(),
  preview: z.boolean().nullish(),
})

export const MessageSchema = z.object({
  id: z.number().int().nonnegative(),
  sorting: z.number().int().optional(),
  text: z.string(),
  fallback: z.string().nullish(),
  enableFallbackVariable: z.boolean(),
  fallbackVariable: z.string().nullish(),
  price: z.number().nullish(),
  medias: z.array(MessageMediaSchema).nullish(),
  totalSent: z.number().optional(),
  totalReads: z.number().optional(),
  totalResponses: z.number().optional(),
  totalPPVBought: z.number().optional(),
  // Ask about this field, any type os old code
  conditionalPrices: z.any().optional(), // Todo
})

export type Message = z.infer<typeof MessageSchema>

export const MessageSequenceSchema = z.object({
  id: z.number(),
  sequenceKey: z.string().nullish(),
  status: z.nativeEnum(MessageSequenceStatus).nullish(),
  messages: z.array(MessageSchema),
  createdAt: z.string(),
  modifiedAt: z.string().nullish(),
})

export type MessageSequence = z.infer<typeof MessageSequenceSchema>
